import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardTitle,
  Progress,
} from "@/components/ui";
import { formatAmount } from "@/lib/utils";
import { Columns3, UsersRound } from "lucide-react";
import { FormSectionHeader, Loader } from "@/components";
import useOperational from "./useOperational";
import { images } from "@/assets";

const Operational = () => {
  const {
    vendorGlData,
    isVendorGlDataLoading,
    onTopVendorsClick,
    onTopGlClick,
  } = useOperational();

  return (
    <div className="bg-white rounded-lg p-[20px]">
      <FormSectionHeader className="text-[18px] font-[500]">
        Operational Insights
      </FormSectionHeader>
      {isVendorGlDataLoading ? (
        <Loader />
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px]">
          <Card className="bg-amber-100 border-none">
            <CardTitle className="flex flex-row items-center gap-4 px-5 text-[16px] md:text-[20px]">
              <div className="bg-white rounded-full h-[60px] w-[60px] p-2 flex items-center justify-center">
                <UsersRound className="h-[30px] w-[30px]" />
              </div>
              Top 3 Vendors by Spend
            </CardTitle>
            <CardContent className="bg-[rgba(255,255,255,0.7)] mx-5 p-4 rounded-lg shadow-lg">
              <div className="grid grid-cols-1 gap-3">
                <div className="flex flex-row gap-3">
                  <div className="bg-yellow-500 rounded-full p-2 flex items-center justify-center text-white h-[40px] w-[40px]">
                    <UsersRound />
                  </div>
                  <div className="grid grid-cols-1 text-[14px] mt-2 font-[500] gap-1 w-full">
                    {vendorGlData?.data?.topVendors?.length ? (
                      vendorGlData?.data?.topVendors?.map(
                        (data: any, index: number) => (
                          <div
                            className="grid md:grid-cols-1 lg:grid-cols-2 items-center"
                            key={`vendors-${index}`}
                          >
                            <div className="gap-6">
                              {index + 1}. {data?.name || ""}:{" "}
                              <span className="text-yellow-500">
                                {formatAmount(data?.amount || 0)}
                              </span>
                            </div>
                            <Progress
                              value={(data?.amount / 5000) * 100}
                              className=" [&>div]:bg-yellow-500"
                            />
                          </div>
                        )
                      )
                    ) : (
                      <div className="flex items-center justify-center">
                        <img src={images.no_data} className="h-40 w-40" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </CardContent>
            <CardFooter className="flex justify-end">
              <Button
                onClick={onTopVendorsClick}
                disabled={!vendorGlData?.data?.topVendors?.length}
              >
                View Details
              </Button>
            </CardFooter>
          </Card>
          <Card className="bg-blue-100 border-none">
            <CardTitle className="flex flex-row items-center gap-4 px-5 text-[16px] md:text-[20px]">
              <div className="bg-white rounded-full h-[60px] w-[60px] p-2 flex items-center justify-center">
                <Columns3 className="h-[30px] w-[30px]" />
              </div>
              Top 3 GL by Spend
            </CardTitle>
            <CardContent className="bg-[rgba(255,255,255,0.7)] mx-5 p-4 rounded-lg shadow-lg">
              <div className="grid grid-cols-1 gap-3">
                <div className="flex flex-row gap-3">
                  <div className="bg-yellow-500 rounded-full p-2 flex items-center justify-center text-white h-[40px] w-[40px]">
                    <Columns3 />
                  </div>
                  <div className="grid grid-cols-1 text-[14px] mt-2 font-[500] gap-1 w-full">
                    {vendorGlData?.data?.topGls?.length ? (
                      vendorGlData?.data?.topGls?.map(
                        (data: any, index: number) => (
                          <div
                            className="grid md:grid-cols-1 lg:grid-cols-2 items-center"
                            key={`gls-${index}`}
                          >
                            <div className="gap-6">
                              {index + 1}. {data?.name || ""}:{" "}
                              <span className="text-primary">
                                {formatAmount(data?.amount || 0)}
                              </span>
                            </div>
                            <Progress value={(data?.amount / 5000) * 100} />
                          </div>
                        )
                      )
                    ) : (
                      <div className="flex items-center justify-center">
                        <img src={images.no_data} className="h-40 w-40" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </CardContent>
            <CardFooter className="flex justify-end">
              <Button
                onClick={onTopGlClick}
                disabled={!vendorGlData?.data?.topGls?.length}
              >
                View Details
              </Button>
            </CardFooter>
          </Card>
        </div>
      )}
    </div>
  );
};

export default Operational;
